import { render, staticRenderFns } from "./follow.pug?vue&type=template&id=81b75790&lang=pug&"
import script from "./follow.ts?vue&type=script&lang=ts&"
export * from "./follow.ts?vue&type=script&lang=ts&"
import style0 from "./follow.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports